import { Button } from "@omni/ui/components/Button/button.component";
import { isEmpty } from "lodash-es";
import { useEffect, useState } from "react";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { PromotionCode } from "@/types/service/cart/shared";

import { PromotionInputField } from "./promotionInput/promotionInputField.component";
import { PromotionList } from "./promotionList/promotionList.component";

import "./discount.scss";

type Props = {
    children?: string;
    promotionCodes: Array<PromotionCode>;
    isLoading: boolean;
    cartHasItems: boolean;
    addPromotionCode: (values: string, bonusCardNumber?: string) => void;
    removePromotionCode: (code: string) => void;
};

const Discount = ({
    promotionCodes,
    removePromotionCode,
    addPromotionCode,
    isLoading,
    cartHasItems
}: Props) => {
    const { t } = useGranite();
    const [active, setActive] = useState(promotionCodes.length > 0);

    useEffect(() => {
        return function cleanUp() {
            setActive(false);
        };
    }, []);

    return (
        <>
            {cartHasItems && (
                <>
                    {active && (
                        <div className="discount-wrapper">
                            <PromotionInputField
                                addPromotionCode={addPromotionCode}
                                loading={isLoading}
                                setActive={setActive}
                                autofocus={isEmpty(promotionCodes)}
                            />
                            <PromotionList
                                promotions={promotionCodes}
                                removePromotionCode={removePromotionCode}
                            />
                        </div>
                    )}
                    {!active && (
                        <Button
                            className={"discount__button"}
                            test="discount-button-fillInDiscountCode"
                            color="link"
                            type="button"
                            onClick={() => setActive(true)}
                        >
                            <div className={"discount__button__tag"}></div>
                            <i className="las la-tags pr-1 d-none d-md-inline" />
                            <span className={"discount__button__content"}>
                                {t(
                                    "general.checkout.discount.label.fillInDiscountCode"
                                )}
                            </span>
                            <span
                                className={"discount__button__marker d-md-none"}
                            >
                                ●
                            </span>
                        </Button>
                    )}
                </>
            )}
        </>
    );
};

export { Discount };
